module.exports = __webpack_public_path__ + "img/entity_03.4353195f.jpg";